import React from 'react';
import { DynamicIcon } from 'legion-ui';

function NewRelease({ release, setNewRelease }) {
  const handleClick = () => {
    window.location = '/release-notes/website';
  };

  const handleClose = () => {
    localStorage.setItem('newRelease', release);
    setNewRelease(release.keyNewRelease);
  };
  return (
    <div className="bx--grid bx--col-lg-12 ">
      <div className="headrelease">
        <div className="wording">
          <span>New Release Version {release} </span>
          <div style={{ margin: '0px 10px', color: '#A5A5A5' }}>|</div>
          <div className="details-release" role="button" tabIndex={0} onClick={handleClick} onKeyDown={handleClick}>
            See Details
          </div>
        </div>
        <div
          className="close"
          role="button"
          tabIndex={0}
          onClick={handleClose}
          onKeyDown={handleClose}
          aria-label="close"
        >
          <DynamicIcon size={15} name="X" />
        </div>
      </div>
    </div>
  );
}

export default NewRelease;
